const supportedLocales = ['en', 'ar']
const fallbackLocale = supportedLocales[0]

const getPreferredLocale = () => {
  const localeFromURL = window.location.pathname.split('/')[1]

  return supportedLocales.includes(localeFromURL) ? localeFromURL : fallbackLocale
}

export const useLocale = () => ({
  locale: <LocaleType> getPreferredLocale(),
  fallbackLocale
})
